import { useEffect, useRef, useState } from 'react';

export default function useThrottledLoading(isLoading: boolean, delay = 500) {
  const [isThrottled, setIsThrottled] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (isLoading) {
      setIsThrottled(true);

      if (timeoutRef.current) {
        console.log('clearing timeout');
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        setIsThrottled(false);
        timeoutRef.current = null;
      }, delay);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  return isThrottled || isLoading;
}
